import {CommonModule} from '@angular/common';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {
    OrganizationEenCustomerAccountComponent,
} from '../edit-organization/organization-een-customer-account/organization-een-customer-account.component';

@Component({
    selector: 'app-organization-een-account-page',
    standalone: true,
    imports: [CommonModule, OrganizationEenCustomerAccountComponent],
    template: `
        <section data-testid="organization-een-account-page">
            <app-organization-een-customer-account
                [organizationId]="organizationId"
                [hidePanelHeading]="true">
            </app-organization-een-customer-account>
        </section>
    `,
})
export class OrganizationEenAccountPageComponent implements OnInit, OnDestroy {
    organizationId: number | null = null;
    private sub: Subscription | null = null;

    constructor(private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.sub = this.route.parent!.paramMap.subscribe((params) => {
            const raw = params.get('organizationId');
            const id = raw ? Number(raw) : NaN;
            this.organizationId = Number.isFinite(id) ? id : null;
        });
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }
}
